import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import { Grid } from "react-loader-spinner"
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Select from "react-select"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import cresusFond from "../../assets/images/prop1.png"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Flip } from "react-toastify"
import axios from "axios"
import { useForm } from "react-hook-form"
import API from "../../api";

const Login = props => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({})
  const [anneeScolaire, setAnneeScolaire] = useState([])
  const [api_password, setApi_paasword] = useState("3KbmGc5tZhuDbPtb")
  const [selectAnneeScolaire, setSelectAnneeScolaire] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    const res = await API.get("annee/select").then(res => {
      setAnneeScolaire(res.data.Annee[0].ListAnnee)
      setSelectAnneeScolaire(res.data.Annee[0].CurrentAnnee[0])
    })
  }, [])

  const onSubmit = async data => {
    setLoading(false)
    var anneeScolaire = selectAnneeScolaire.value
    const res = await API.post(
      "login",
      {
        password: data.password,
        email: data.email,
        apipassword: api_password,
        annee_id:anneeScolaire,
        role:1,
        compte:1
      }
    )
    if (res.data.status === 200) {
      localStorage.setItem("I18N_LANGUAGE", "fr")
      localStorage.setItem("userAuthScolarite", JSON.stringify(res.data))
      localStorage.setItem("cloture", JSON.stringify(res.data.user.cloture))
      localStorage.setItem("UserMenu",JSON.stringify(res.data.user.menu))
      localStorage.setItem("anneeScolaire", JSON.stringify(anneeScolaire))
      props.history.push("/dashboard")
      window.location.reload(false)
    } else if(res.data.errNum === 400) {
      setLoading(true)
      toast.error("⛔ Veuillez vérifier votre CIN et mot de passe ou l'année scolaire!", {
        containerId: "A",
      })
    }else if(res.data.errNum === 401) {
      setLoading(true)
      toast.error("⛔ "+res.data.msg, {containerId: "A", })
    }else{
      setLoading(true)
      toast.error("⛔ Vous n'avez pas de compte pour cette année scolaire !", {
        containerId: "A",
      })
    }
  }

  return (
    <div>
      {loading ? (
        <div
          style={{
            backgroundImage: `url(${cresusFond})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100vh",
            width: "100vw",
          }}
        >
          <div style={{ paddingTop: "11%" }}>
            <Container>
              <Row className="justify-content-center">
                <Col md={9} lg={8} xl={7}>
                  <Card style={{backgroundColor:"#525351",borderRadius:"10px",boxShadow:"rgba(0, 0, 0, 0.63) 0px 4px 8px"}} className="overflow-hidden">
                    <div>
                      <Row>
                        <Col className="justify-content-center pt-4">
                          <h1
                            style={{
                              color: "#ffffff",
                              textAlign: "center",
                            }}
                          >
                            Espace Scolarité
                          </h1>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-4">
                      <div className="p-2">
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmit(onSubmit)}
                        >
                          <div className="mb-3">
                            <input
                              name="email"
                              placeholder="Entrer email"
                              type="text"
                              className="form-control"
                              {...register("email", { required: true })}
                            />
                            {errors.email && (
                              <span style={{ color: "red" }}>
                                required email
                              </span>
                            )}
                          </div>
                          <div className="mb-3">
                            <input
                              name="password"
                              placeholder="Entrer password"
                              type="password"
                              className="form-control"
                              {...register("password", { required: true })}
                            />
                            {errors.password && (
                              <span style={{ color: "red" }}>
                                required password
                              </span>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Année universitaire
                            </Label>
                            <Select
                              options={anneeScolaire}
                              isSearchable={true}
                              value={selectAnneeScolaire}
                              onChange={e => setSelectAnneeScolaire(e)}
                            />
                          </div>
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1"></Label>
                          </div>
                          <div className="mt-3 d-grid">
                            <button

                              style={{
                                backgroundColor: "#3ba897",
                                borderColor: "#3ba897",
                              }}
                              className="btn btn-success mb-2 me-2"
                              type="submit"
                            >
                              CONNECTER
                            </button>
                          </div>
                        </form>
                      </div>
                    </CardBody>
                    <div className="mt-1 text-center">
                      <p style={{color:"white" , marginBottom:"15px"}}>
                        © 2005 -  {new Date().getFullYear()} Cresus. Crafted with
                        <i className="mdi mdi-heart text-danger" /> by
                        <a style={{color:"white"}} href="https://cresus.pro/"> cresus.pro</a>
                      </p>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
            <ToastContainer
              transition={Flip}
              enableMultiContainer
              containerId={"A"}
              position={toast.POSITION.TOP_RIGHT}
              autoClose={2500}
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-50px",
            marginLeft: "-50px",
          }}
        >
          <Grid heigth="100" width="100" color="#86B5E9" ariaLabel="loading" />
        </div>
      )}
    </div>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
